import { responseHero } from "../utils/axiosInterceptor";

export interface NewsLetterNonViewerRawResponse {
    id: number;
    newsletterGroup: {
        id: number;
        NewsLetterSubscription: {
            user_id: number;
            user: {
                name: string;
                email: string;
            };
        }[];
    };
}

export const getNewsLetterNonViewers = async (groupId: number, videoId: string): Promise<NewsLetterNonViewerRawResponse[]> => {
    if (!videoId || !groupId) return [];
    
    try {
        const response = await responseHero.get(`${process.env.REACT_APP_API_URL}/nonviewers/${groupId}/${videoId}`);
        return response.data as NewsLetterNonViewerRawResponse[];
    } catch (error) {
        console.error("Hiba a getNewsLetterNonViewers hívásakor:", error);
        return [];
    }
};